import { api_base } from '../api';

export const Colors = {
	get(cat, cb) {
		$.ajax({
			url: api_base + '/colors/' + cat,
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/store/api/colors.js